import React, {useEffect, useRef, useState} from 'react';
import {FixedSizeList as List} from 'react-window';
const listHeight = 250;
const itemHeight = 25;
function MenuList(props) {
   const {options, children, getValue, focusedOption} = props;
   const [value] = getValue();
   const initialOffset = options.indexOf(value) * itemHeight;
   const listRef = useRef(null);

   /*    
   const [scrollOffset, setscrollOffset] = useState(0);
   function handleKeyDown(event) {
      let scrollDistance = 0;
      if (scrollOffset > 75) {
         scrollDistance + 75;
      }
      switch (event.code) {
         case 'ArrowUp': // page up
            if (scrollOffset !== 0) {
               listRef.current.scrollTo(scrollOffset - scrollDistance);
            }
            break;
         case 'ArrowDown': // page down
            listRef.current.scrollTo(scrollOffset + scrollDistance);
            break;
      }
   }
   useEffect(() => {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []); 
   */

   return (
      <List
         ref={listRef}
         height={listHeight}
         itemCount={children.length}
         itemSize={itemHeight}
         initialScrollOffset={initialOffset}
         /* 
         onItemsRendered={(e) => {}}
         onScroll={(e) => {
         }} 
         */
      >
         {({index, style}) => {
            return (
               <div tabIndex={index} style={{...style, textAlign: 'start'}}>
                  {children[index]}
               </div>
            );
         }}
      </List>
   );
}

export default MenuList;
